export default "__VITE_ASSET__Cdse7zp2__"